<template>
 <div class="technologyApplication">
   <div class="t_show_block">
     <div class="block_item" v-for="item in showList" :key="item.title">
       <div class="item_title HuXiaoBo">
        {{item.title}}
       </div>
       <div class="item_photo">
         <img :src="item.img" alt="" v-if="item.img">
       </div>
       <div class="item_content">
        {{item.content}}
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import jsonData from '/public/static/js/json/operateManage.json';
export default {
  name: 'technologyApplication',
  data() {
    return {
       showList: []
    }
  },
  mounted() {
   this.showList = jsonData.technologyApplication;
  }
}
</script>

<style scoped lang="scss">
 .technologyApplication {
   padding-top: 20px;
   .t_show_block {
     width: 90%;
     display: flex;
     justify-content: space-around;
     align-items: center;
     margin: 0 auto;
     .block_item {
       flex: 1;
       padding-left: 30px;
       padding-right: 30px;
       display: flex;
       flex-direction: column;
       align-items: center;
       height: 360px;
       .item_title {
         font-size: 25px;
         margin-bottom: 20px;
       }
       .item_photo {
         height: 173px;
         width: 280px;
         margin-bottom: 20px;
         img {
           width: 100%;
           height: 100%;
         }
       }
       .item_content {
         font-size: 18px;
         letter-spacing: 2px;
       }
     }
   }
 }
</style>
